import { useStatsigClient } from '@statsig/react-bindings';
import { dynamicConfigs, collegeProspectPowerConfigKeys } from '../../utils/statsig';

// Custom hook to get the dynamic config for the college prospect power feature(s)
export const useCPPDynamicConfig = () => {
    const { client } = useStatsigClient();
    const config = client.getDynamicConfig(dynamicConfigs.COLLEGE_PROSPECT_POWER)?.value;

    const isCollegeProspectPowerEnabled = config?.isCollegeProspectPowerEnabled || false;
    const features = config?.features || {};

    const extractFeatureConfig = () => {
        return collegeProspectPowerConfigKeys.reduce((acc, key) => {
            acc[key] = features[key] || false;
            return acc;
        }, {});
    };

    const featureConfig = extractFeatureConfig();

    return {
        isCollegeProspectPowerEnabled,
        ...featureConfig,
    };
};
